import React, { Component } from 'react'

class ND extends Component {
  render() {
    return (
      <symbol id="statesvg-ND" width="100" height="100" viewBox="0 0 100 100">
        <path d="M96.07,71.82,51.68,73.06,6.93,72l2.3-52.11,38,1.07L86,20.07,87.47,26,87,27.87l.71,6.82,3.37,9L92,54l.89,1.15L92.7,60l2.57,5.41Z" />
      </symbol>
    )
  }
}

export default ND
